import styled from "styled-components";

export const LogAttachmentsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 100%;
  padding: 8px 8px 2px 0;

  &.log-attachments--list {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 8px;
    width: 100%;
    padding: 8px 0 2px;
  }

  & .log-attachment--row {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    min-height: 64px;
    padding: 8px 10px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    background: #fff;
  }

  & .log-attachment--main {
    display: flex;
    flex: 1;
    align-items: center;
    min-width: 0;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
  }

  & .log-attachment--row-icon {
    flex: 0 0 48px;
    width: 48px;
    height: 48px;
    object-fit: contain;
  }

  & .log-attachment--name {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
    overflow: hidden;
    color: #1677ff;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & .log-attachment--main:hover .log-attachment--name,
  & .log-attachment--main:focus-visible .log-attachment--name {
    color: #4096ff;
  }

  & .log-attachment--main:focus-visible,
  & .log-attachment--row-download:focus-visible {
    outline: 2px solid #7a294f;
    outline-offset: 2px;
  }

  & .log-attachment--row-download {
    display: inline-flex;
    flex: 0 0 28px;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin-left: 8px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #8c8c8c;
    cursor: pointer;
  }

  & .log-attachment--row-download:hover,
  & .log-attachment--row-download:focus-visible {
    color: #7a294f;
  }

  & .log-attachment--tile {
    position: relative;
    width: 40px;
    height: 40px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    background: #fff;
  }

  & .log-attachment--tile {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid #7a294f;
      outline-offset: 1px;
    }

    & img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }

  & .log-attachment--uploading {
    cursor: default;

    & img {
      opacity: 0.25;
    }
  }

  & .log-attachment--loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7a294f;
    font-size: 20px;
    pointer-events: none;
  }

  & .log-attachment--corner-action {
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: none;
    background: transparent;
    color: #8c8c8c;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;

    &:focus {
      outline: none;
    }

    &:disabled {
      color: #bfbfbf;
      cursor: not-allowed;
    }
  }

  & .log-attachment--download:hover,
  & .log-attachment--download:focus {
    color: #7a294f;
  }

  & .log-attachment--download {
    top: auto;
    bottom: -5px;
  }

  & .log-attachment--remove:hover:not(:disabled),
  & .log-attachment--remove:focus:not(:disabled) {
    color: #ff4d4f;
  }

  & .log-attachment--remove {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.15s ease;
  }

  & .log-attachment--tile:hover .log-attachment--remove,
  & .log-attachment--tile:focus-within .log-attachment--remove {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;
